module.exports = __webpack_public_path__ + "static/assets/ac31018c2180bdd055a650dc8e936f77.svg";